import {
  Box,
  HStack,
  Input,
  InputGroup,
  InputLeftAddon,
  Select as ChakraSelect,
  Text,
} from "@chakra-ui/react";
import type { Ref } from "react";
import type { BudgetData } from "./BudgetSelector";

type GuidedBudgetEditorProps = {
  budget?: BudgetData;
  onChangeBudgetType: (type: "daily" | "lifetime") => void;
  onChangeBudgetAmount: (amount: number | null) => void;
  /** When set (e.g. modal initial focus), forwards to the dollar amount input. */
  amountInputRef?: Ref<HTMLInputElement>;
};

export default function GuidedBudgetEditor({
  budget,
  onChangeBudgetType,
  onChangeBudgetAmount,
  amountInputRef,
}: GuidedBudgetEditorProps) {
  return (
    <Box
      p={4}
      borderRadius="xl"
      border="1px solid"
      borderColor="gray.200"
      bg="white"
      w="full"
    >
      <Text fontSize="md" fontWeight="semibold" color="gray.800" mb={1}>
        Campaign budget
      </Text>
      <Text fontSize="sm" color="gray.600" mb={4}>
        Meta will automatically distribute your budget to the best opportunities
        across your campaign.
      </Text>
      <HStack spacing={4} align="stretch" w="full">
        <Box flex={1} w="50%">
          <ChakraSelect
            value={budget?.type === "daily" ? "daily" : "lifetime"}
            onChange={(e) =>
              onChangeBudgetType(
                e.target.value === "daily" ? "daily" : "lifetime"
              )
            }
            size="md"
            borderRadius="md"
            borderColor="gray.200"
            bg="white"
          >
            <option value="lifetime">Lifetime budget</option>
            <option value="daily">Daily budget</option>
          </ChakraSelect>
        </Box>
        <InputGroup flex={1} w="50%">
          <InputLeftAddon
            borderColor="gray.200"
            bg="white"
            color="gray.600"
            borderRightWidth="0"
            children="$"
          />
          <Input
            ref={amountInputRef}
            type="number"
            step={0.01}
            min={0}
            placeholder="0.00"
            value={
              budget?.amount?.amount != null ? String(budget.amount.amount) : ""
            }
            onChange={(e) => {
              const value = e.target.value;
              onChangeBudgetAmount(value === "" ? null : parseFloat(value));
            }}
            borderColor="gray.200"
            bg="white"
            borderRadius="md"
            pl={3}
          />
        </InputGroup>
      </HStack>
    </Box>
  );
}
